module.exports = __webpack_public_path__ + "img/BY.4506d74f.svg";